/*
 * @Author: your name
 * @Date: 2022-01-12 10:41:50
 * @LastEditTime: 2022-01-12 10:47:16
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wp-empowerment-tools-web\src\services\customerJorney.ts
 */

import { CUSTOMER_JOURNEY } from "../const"
import request from "../utils/request"

const closeJourney = (params: any) => {
  return request.post(`${CUSTOMER_JOURNEY.closeJourney}`, { data: params })
}

const editJourney = (params: any) => {
  return request.post(`${CUSTOMER_JOURNEY.editJourney}`, { data: params })
}

export { editJourney, closeJourney }
